/* Boton "Continuar mi compra por WhatsApp" de la ficha de producto.
   Vive en su propio archivo, cargado solo desde sections/main-product.liquid:
   no toca theme.js ni nada del carrito lateral.

   No duplica la resolucion de variantes de theme.js. En su lugar LEE el estado
   que theme.js ya deja en el DOM:
     - input[name="id"]       -> id de la variante actual (lo actualiza initVariants)
     - input[name="quantity"] -> cantidad actual (la actualizan los botones +/-)
     - [data-product-variants]-> JSON con el precio y el titulo de cada variante
   Asi el precio y el nombre de variante salen siempre del dato real de Shopify. */
(function () {
  'use strict';

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return 'S/ ' + (Number(cents || 0) / 100).toFixed(2);
  }

  // formatMoney puede devolver entidades HTML segun el formato de la tienda.
  // En WhatsApp va texto plano.
  function moneyPlain(cents) {
    var div = document.createElement('div');
    div.innerHTML = money(cents);
    return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function telefono(bruto) {
    var v = String(bruto || '').trim();
    if (!v) return '';
    var m = /[?&]phone=(\d+)/.exec(v) || /wa\.me\/(\d+)/.exec(v);
    return m ? m[1] : v.replace(/\D/g, '');
  }

  function init(boton) {
    var raiz = boton.closest('[data-product-root]');
    var form = raiz && raiz.querySelector('[data-product-form]');
    if (!raiz || !form) return;

    var tel = telefono(boton.getAttribute('data-wa-phone'));
    if (!tel) return;

    var titulo = boton.getAttribute('data-wa-title') || '';
    var url = boton.getAttribute('data-wa-url') || window.location.href;

    var variantes = [];
    var json = raiz.querySelector('[data-product-variants]');
    try { variantes = JSON.parse((json && json.textContent) || '[]'); } catch (e) { variantes = []; }

    function varianteActual() {
      var idInput = form.querySelector('[name="id"]');
      var id = idInput && String(idInput.value || '');
      if (!id) return null;
      for (var i = 0; i < variantes.length; i++) {
        if (String(variantes[i].id) === id) return variantes[i];
      }
      return null;
    }

    function actualizar() {
      var variante = varianteActual();
      var qtyInput = form.querySelector('input[name="quantity"]');
      var cantidad = Math.max(1, Number((qtyInput && qtyInput.value) || 1));
      // Sin variante localizada se deja el enlace de respaldo, nunca un precio inventado
      if (!variante) return;

      var unidad = Number(variante.price || 0);
      var lineas = ['Hola 👋 Quiero comprar este producto:', '', titulo];

      // Solo si hay una variante real: Shopify usa "Default Title" cuando no la hay
      if (variante.title && variante.title !== 'Default Title') {
        lineas.push('Variante: ' + variante.title);
      }

      lineas.push(
        '',
        'Cantidad: ' + cantidad,
        'Precio: ' + moneyPlain(unidad) + ' c/u',
        'Total: ' + moneyPlain(unidad * cantidad),
        '',
        '¿Me ayudan a coordinar mi pedido? 😊',
        '',
        'Producto:',
        url
      );

      boton.href = 'https://wa.me/' + tel + '?text=' + encodeURIComponent(lineas.join('\n'));
    }

    // theme.js lanza un "change" con burbujeo sobre la cantidad al pulsar +/-, y
    // los selectores de variante disparan el suyo. El setTimeout deja que sus
    // manejadores terminen antes de leer: los botones +/- los atiende un listener
    // a nivel de document, que se ejecuta despues de este.
    var pendiente = null;
    function programar() {
      window.clearTimeout(pendiente);
      pendiente = window.setTimeout(actualizar, 0);
    }
    form.addEventListener('change', programar);
    form.addEventListener('input', programar);
    form.addEventListener('click', programar);

    actualizar();
  }

  function arrancar() {
    document.querySelectorAll('[data-product-whatsapp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
